import React, { useState } from 'react'
import Button from '../../../atoms/Button/Button'
import TextField from '../../../atoms/TextField/TextField'
import CurrencyField from '../../CurrencyField/CurrencyField'
import CurrencyText from '../../../atoms/Typography/CurrencyText/CurrencyText'
import TextInput from 'views/components/atoms/TextField/TextInput'
import { TextFieldTypes } from 'views/components/atoms/TextField/text-field.types'
import { validatePaymentReference } from 'utils/validation'
import styles from './NoAttachedLeaseBeneficiary.module.scss'

type TState = {
  reference: string
  amount: number
}

interface INoAttachedLeaseBeneficiaryProps {
  primaryOwnerPartyId?: string
  state: TState
  setState: (state: Partial<TState>) => void
  onNewBeneficiaryAdded: (beneficiary: { type: string; value: any }) => void
  unallocatedAmount: number
}

const NoAttachedLeaseBeneficiary = ({
  primaryOwnerPartyId,
  state,
  setState,
  onNewBeneficiaryAdded,
  unallocatedAmount,
}: INoAttachedLeaseBeneficiaryProps) => {
  const [nextStep, setNextStep] = useState<'reference' | 'amount'>('reference')
  const [referenceError, setReferenceError] = useState<string | undefined>(undefined)

  const renderNextField = () => {
    if (nextStep === 'reference') {
      return (
        <TextField
          inputComponent={
            <TextInput
              type={TextFieldTypes.text}
              name="reference"
              onChange={({ target }: any) => {
                setState({ reference: target.value })
                setReferenceError(validatePaymentReference(target.value))
              }}
              placeholder=""
              ref={(ref: any) => {
                ref?.focus()
              }}
            />
          }
          label="Payment reference"
          error={referenceError}
        />
      )
    }

    if (nextStep === 'amount') {
      return (
        <CurrencyField
          name="amount"
          placeholder=""
          label="Amount (optional)"
          labelHint="Leave blank to set the amount later"
          value={state.amount}
          onChange={({ target }: any) => setState({ amount: target.value || 0 })}
          error={
            state.amount > unallocatedAmount ? (
              <span>
                Can&apos;t exceed unallocated amount of <CurrencyText>{unallocatedAmount}</CurrencyText>
              </span>
            ) : (
              false
            )
          }
        />
      )
    }
  }

  const isStateValid = () => state.reference && !referenceError && state.amount <= unallocatedAmount

  return (
    <div className={styles.root}>
      <div className={styles.input}>{renderNextField()}</div>

      {nextStep === 'reference' && (
        <Button
          className={styles['next-button']}
          disabled={!state.reference || !!referenceError}
          size="sm"
          onClick={() => setNextStep('amount')}
        >
          Next
        </Button>
      )}

      {nextStep === 'amount' && (
        <Button
          className={styles['add-beneficiary-button']}
          disabled={!isStateValid()}
          size="sm"
          onClick={() =>
            onNewBeneficiaryAdded({
              type: 'ConsolidatedWalletBeneficiary',
              value: {
                partyId: primaryOwnerPartyId,
                partyTag: 'Owner',
                reference: state.reference,
                amount: state.amount,
                vat: false,
              },
            })
          }
        >
          Save
        </Button>
      )}
    </div>
  )
}

export default NoAttachedLeaseBeneficiary
